const constants = {
  REQUEST_DATA: 'REQUEST_DATA',
  SETTER: 'SETTER',
};

export default constants;
